import { createSlotsContext } from '@grandvisionhq/slots';

const [CancelAndReturnsModalContentSlotsProvider, useCancelAndReturnsModalContentSlot] = createSlotsContext({
    displayName: 'CancelAndReturnsModalContentSlot'
});

export { CancelAndReturnsModalContentSlotsProvider, useCancelAndReturnsModalContentSlot };
//# sourceMappingURL=CancelAndReturnsModalContentContext.js.map
